import { FC, useCallback } from 'react';

import useScrollTrigger from '../hooks/use-scroll-trigger';
import { styled } from '../theme';
import { Fab } from './Fab';
import Fade from './Fade';
import SvgIcon from './SvgIcon';

const Wrapper = styled('div')({
    position: 'fixed',
    bottom: 40,
    right: 40,
});

const ArrowUp = styled(SvgIcon)({
    transform: 'scaleY(-1)',
});

const buttonStyle = { background: '#1FBA59', color: 'white' };

type Props = {
    target?: Window | HTMLElement | null;
};

const ScrollToTop: FC<Props> = ({ target }) => {
    const trigger = useScrollTrigger({ target });
    const handleClick = useCallback(() => {
        const anchor = document.querySelector('#back-to-top-anchor');

        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, []);

    if (!target) {
        return null;
    }

    return (
        <Wrapper onClick={handleClick} role="presentation">
            <Fade in={trigger}>
                <Fab aria-label="scroll back to top" size="lg" style={buttonStyle}>
                    <ArrowUp src="/icons/ic-arrow-down.svg" size="md" />
                </Fab>
            </Fade>
        </Wrapper>
    );
};

export default ScrollToTop;
